import React, { useState } from "react";
import { useLocation } from 'react-router-dom';
import { jsonObjectRearrange } from "../config/jsonObjectRearrange";
import { useNavigate } from 'react-router-dom';

const Template1 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formData = location.state.formData;

  const sendDataToRails = async () => {
    const configeredObject = jsonObjectRearrange(formData)
    const data = {
      config: configeredObject,
      image: formData.image,
      // pdf_file: `http://localhost:3002/${filePath}.pdf`
    };
    const response = await fetch(`${process.env.REACT_APP_API_URL}/biodata`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    const responseData = await response.json();
    alert('Got the result successfully');
    navigate('/result', { state: { biodata: responseData } });
  }

  function getValueByLabel(targetLabel) {
    for (const step in formData) {
      if (formData.hasOwnProperty(step)) {
        const stepData = formData[step];
        for (const item of stepData) {
          if (item.label === targetLabel) {
            return item.value;
          }
        }
      }
    }
    return null; // Return null if label is not found
  }

  function date_formatter(input) {
    const input_format = new Date(input);
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return input_format.toLocaleDateString("mar-IN", options)
  }

  function marathi_label(targetLabel) {
    for (const step in formData) {
      if (formData.hasOwnProperty(step)) {
        const stepData = formData[step];
        for (const item of stepData) {
          if (item.label === targetLabel) {
            return item.labelTitle;
          }
        }
      }
    }
    return null; // Return null if label is not found
  }

  function renderField(label) {
    const value = getValueByLabel(label);

    if (value) {
      return (
        <p>
          <strong>{marathi_label(label)}:</strong> {value}
        </p>
      );
    }

    return null;
  }


  return (
    <div className="contentbar mb-3">
      <div className="row justify-content-center">
        <div className="col-md-12 col-lg-12 col-xl-12">
          <div className="text-center mt-3 mb-5">
            <h4>परिचय पत्रक</h4>
          </div>
        </div>
      </div>

      <div className="row justify-content-center">

        <div className="col-md-12 col-lg-10 col-xl-10">
          <div className="card m-b-30">
            <div className="card-body">
              <div className="invoice">
                <div className="invoice-head">
                  <div className="row">
                    <div className="col-12 col-md-8 col-lg-8">
                      <div className="invoice-name">
                        <img src={`${process.env.REACT_APP_API_URL}/uploads/${formData.image}`} className="img-fluid" alt="invoice-logo" height={300} width={250} />
                      </div>
                      <h4>{getValueByLabel("name")}</h4>
                      <p className="mb-3">{getValueByLabel("job")}</p>
                      {renderField("birthName")}
                      {getValueByLabel("birthDate") && (
                        <p>
                          <strong>{marathi_label("birthDate")}:</strong> {date_formatter(getValueByLabel("birthDate"))}{" "}
                          <strong>{marathi_label("birthTime")}:</strong> {getValueByLabel("birthTime")}
                        </p>
                      )}
                      {renderField("birthPlace")}
                      {renderField("castReligion")}
                      {renderField("familyGod")}
                      {renderField("gotr")}
                      {renderField("devak")}
                      {renderField("nakshytra")}
                      {renderField("rashi")}
                      {renderField("gan")}
                      {renderField("nadi")}
                      {renderField("height")}
                      {renderField("color")}
                      {renderField("bloodgroup")}
                      {renderField("aboutme")}


                    </div>

                    <div className="col-12 col-md-4 col-lg-4">
                      {renderField("job")}
                      {renderField("education")}
                      {renderField("income")}
                      <h3>कौटुंबिक माहिती</h3>

                      {renderField("fatherName")}
                      {renderField("motherName")}
                      {renderField("brother1")}
                      {renderField("brother2")}
                      {renderField("brother3")}
                      {renderField("sister1")}
                      {renderField("sister2")}
                      {renderField("sister3")}
                      {renderField("paternalUncle1")}
                      {renderField("paternalUncle2")}
                      {renderField("maternalUncle1")}
                      {renderField("maternalUncle2")}
                      {renderField("grandfather")}
                      {renderField("relatives")}
                      {renderField("expections")}
                      <h3>संपर्क</h3>
                      {renderField("address")}
                      {renderField("mobileNumber")}
                      <button className='btn btn-primary' onClick={sendDataToRails}>Generate File</button>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Template1;